import './index.scss'
// Select only inputs that are NOT inside hidden containers
const validFields = document.querySelectorAll(
    '.gfield:not(.gfield_visibility_hidden):not(.gform_hidden) input, ' +
    '.gfield:not(.gfield_visibility_hidden):not(.gform_hidden) textarea, ' +
    '.gfield:not(.gfield_visibility_hidden):not(.gform_hidden) select'
);

validFields.forEach(field => {
    const handleValue = () => {
        const container = field.closest('.gfield');
        if (field.value.trim() !== "") {
            container.classList.add('has-content');
        } else {
            container.classList.remove('has-content');
        }
    };

    // Initial check
    handleValue();

    // Event listeners
    field.addEventListener('blur', handleValue);
    field.addEventListener('input', handleValue);
    field.addEventListener('change', handleValue);
});